import Header from './Header';
import Sidebar from './Sidebar';
import MainContent from './MainContent';
import Footer from './Footer';
import { ReactNode } from 'react';

export default function DashboardShell({ children }: { children: ReactNode }) {
  return (
    <div className="app-layout">
      <Header />
      <Sidebar />
      <MainContent>{children}</MainContent>
      <Footer />
      {/*<StudySelector />*/}
    </div>
  );
}
